module.exports = __webpack_public_path__ + "static/img/alipay-pay.fc1390b3.png";